import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-bell',
  templateUrl: './icon-bell.component.html',
  styleUrls: ['./icon-bell.component.scss'],
})
export class IconBellComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
